export type InviteCallback = {
    email: string | null;
    token: string;
};


const INVITE_PATH_REGEXP = /^\/invite\/([^/?#]+)\/?$/;


/** Разбирает callbackUrl вида `/invite/<token>/?email=<адрес>`; для остальных адресов возвращает null. */
export const parseInviteCallbackUrl = (callbackUrl: string | null | undefined): InviteCallback | null => {
    if (!callbackUrl || !callbackUrl.startsWith('/') || callbackUrl.startsWith('//')) return null;

    let url: URL;

    try {
        url = new URL(callbackUrl, 'http://local.invalid');
    } catch {
        return null;
    }

    const match = INVITE_PATH_REGEXP.exec(url.pathname);

    if (!match) return null;

    return {
        token: decodeURIComponent(match[1]),
        email: url.searchParams.get('email') || null,
    };
};
